import { render, staticRenderFns } from "./StoneMakes.vue?vue&type=template&id=67ff1f1a&"
import script from "./StoneMakes.vue?vue&type=script&lang=js&"
export * from "./StoneMakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports